(function (ng) {
    ng.module('evo.returns.initiate').component('initiateReturnRoot', {
        templateUrl: ['TEMPLATES_BASE', function (TEMPLATES_BASE) {
            return TEMPLATES_BASE + 'returns/initiate/components/initiateReturnRoot'
        }],
        bindings: {
            createRequest: '<',
            createResponse: '<',
            findOrderModel: '<'
        },
        controller: ['INITIATE_RETURN_MODEL',
            function (INITIATE_RETURN_MODEL) {
                var ctrl = this;

                ctrl.$onInit = function () {
                    ng.extend(ctrl.createRequest, {
                        Comments: '',
                        EmailAddress: '',
                        Items: [],
                        LabelType: null,
                        OrderId: '',
                    });
                    ng.extend(ctrl.findOrderModel, INITIATE_RETURN_MODEL);
                };
            }]
    });
})(angular);